import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DTMFTheme } from 'modules/theme';
import { globalStateSelector } from 'store/selector';
import { callAction, globalAction } from 'store/action';

export class DTMF extends Component {
  constructor(props) {
    super(props);
    this.onBackBtn = this.onBackBtn.bind(this);
    this.onDtmfClick = this.onDtmfClick.bind(this);
  }
  onBackBtn() {
    console.log("onBackBtn");
    const { dynamicUpdate } = this.props
    dynamicUpdate({ key: 'callTab', value: "call" });
  }
  onDtmfClick( digit ) {
    console.log("digit", digit);
    const { callInfo } = this.props;
    this.sendMessage('dtmfSend', {
      sessionId: callInfo.sessionId,
      callId: callInfo.custId,
      dtmf: digit
    });
  }

  sendMessage(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }
  render() {
    return (
      <DTMFTheme onDtmfClick={this.onDtmfClick} onBackBtn={this.onBackBtn} />
    )
  }
}


DTMF.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  callInfo: globalStateSelector.getInfo(state),
});

const dispatchToProps = dispatch => ({
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});

export default connect(stateToProps, dispatchToProps)(DTMF);


// WEBPACK FOOTER //
// src/dialpad/components/layout/DTMF.js